import axios from 'axios';
import toast from 'react-hot-toast';

const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL || '/api',
    timeout: 30_000,
});

api.interceptors.request.use((cfg) => {
    const token = localStorage.getItem('ageon_token');
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    cfg.headers['X-Request-Id'] = `web-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
    cfg.headers['Cache-Control'] = 'no-cache';
    cfg.headers.Pragma = 'no-cache';
    return cfg;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        const status = err.response?.status;
        const msg = err.response?.data?.error || err.message || 'Request failed';
        if (status === 401 && !window.location.pathname.startsWith('/login')) {
            localStorage.removeItem('ageon_token');
            window.location.href = '/login';
        } else if (status >= 400 && status !== 401 && !err.config?.silent) {
            toast.error(msg);
        }
        return Promise.reject(err);
    }
);

export default api;
